import { render, staticRenderFns } from "./RelatedOccupationsT.vue?vue&type=template&id=601dca9d&"
import script from "./RelatedOccupationsT.vue?vue&type=script&lang=js&"
export * from "./RelatedOccupationsT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports